import React, {useState} from 'react';
import {Radio} from 'antd-mobile';
import {DownOutline, UpOutline} from 'antd-mobile-icons';
import {t} from '../../../i18n';
import i18n from '../../../i18n';
import type {DeliveryMethodI18nItemType} from '../../../graphql/queries/getDeliveryMethodI18nConfig';

const getLangKey = (): keyof Pick<DeliveryMethodI18nItemType, 'zh' | 'en' | 'es'> => {
    const raw = (i18n.language || '').toLowerCase();
    if (raw.includes('zh')) return 'zh';
    if (raw.includes('es')) return 'es';
    return 'en';
};

const getDeliveryMethodLabel = (item: DeliveryMethodI18nItemType): string => {
    const lang = getLangKey();
    return (item[lang] || item.en) ?? item.code;
};

export interface DeliveryMethodSelectorProps {
    options: DeliveryMethodI18nItemType[];
    value: string | null;
    onChange: (code: string) => void;
    /** 是否使用卡片容器样式（白底、圆角、阴影） */
    card?: boolean;
    className?: string;
}

const DeliveryMethodSelector: React.FC<DeliveryMethodSelectorProps> = ({
    options,
    value,
    onChange,
    card = true,
    className = ''
}) => {
    const [expanded, setExpanded] = useState(false);

    if (options.length === 0) {
        return null;
    }

    const selectedItem = options.find(i => i.code === value);
    const content = (
        <>
            <h2 className="text-base font-semibold mb-1">{t('pages.delivery.detail.deliveryMethod')}</h2>
            {!expanded ? (
                <>
                    {selectedItem && (
                        <div className="flex items-center justify-between rounded-lg border border-solid border-[var(--adm-color-primary)] p-3 mb-2">
                            <span className="text-[var(--adm-color-primary)]">
                                {getDeliveryMethodLabel(selectedItem)}
                            </span>
                            <Radio value={value ?? undefined} checked />
                        </div>
                    )}
                    <div className="flex justify-center">
                        <button
                            type="button"
                            className="flex items-center gap-1 text-sm text-gray-600"
                            onClick={() => setExpanded(true)}
                        >
                            {t('pages.delivery.temporary.common.expand')}
                            <DownOutline />
                        </button>
                    </div>
                </>
            ) : (
                <>
                    <Radio.Group
                        value={value ?? undefined}
                        onChange={(v) => onChange(v as string)}
                    >
                        {options.map((item) => (
                            <div
                                key={item.code}
                                className={`flex items-center justify-between rounded-lg border border-solid p-3 mb-2 ${value === item.code ? 'border-[var(--adm-color-primary)]' : 'border-gray-200'}`}
                                onClick={() => onChange(item.code)}
                            >
                                <span className={value === item.code ? 'text-[var(--adm-color-primary)]' : ''}>
                                    {getDeliveryMethodLabel(item)}
                                </span>
                                <Radio value={item.code} />
                            </div>
                        ))}
                    </Radio.Group>
                    <div className="flex justify-center mt-2">
                        <button
                            type="button"
                            className="flex items-center gap-1 text-sm text-gray-600"
                            onClick={() => setExpanded(false)}
                        >
                            {t('pages.delivery.temporary.common.collapse')}
                            <UpOutline />
                        </button>
                    </div>
                </>
            )}
        </>
    );

    if (card) {
        return (
            <div className={`mb-2 bg-white rounded-lg p-4 shadow-sm ${className}`}>
                {content}
            </div>
        );
    }

    return (
        <div className={className}>
            {content}
        </div>
    );
};

export default DeliveryMethodSelector;
